<template>
    <div>
      <slot v-if="isPay">
        <b-container>
          <div class="pay-row" style="min-height:200px;">
            <div class="loading" style="display: flex !important; align-items: center; flex-direction: column; position: fixed; left: 50%; top: 50%; transform: translate(-50%, -50%); }">
              <b-spinner style="margin-bottom:20px; width: 3rem; height: 3rem;display:block !important" label=""></b-spinner>
              Yönlendiriliyorsunuz...
            </div>
            <form :action="pay.url" method="post">
              <input v-for="(item,name) in pay" :name="name" :value="item" :key="name" type="hidden">
              <button style="opacity:0" id="button_pay" type="submit"></button>
            </form>
          </div>  
        </b-container>
      </slot>
      
      <slot v-if="!isPay">
        <div>
            <b-modal id="paymentModal" hide-footer>
              <template #modal-title>
                Ödeme için son adım
              </template>
              <div class="d-block text-center">
                  <iframe style="width:100%; height:400px" :src="'/pay?' + Object.keys(pay).map(key => key + '=' + pay[key]).join('&')" frameborder="0"></iframe>
              </div>
            </b-modal>
        </div>
        <div class="subheader">
          <div class="py-1 pt-2 text-center">
            <h5>Kredi Kartı İle <span style="color:red;">Taksitli Çekim</span> Ödeme Formu</h5>
          </div>
        </div>
        <b-container>
          <b-row class="justify-content-md-center">
              <form>
                <ul class="nav nav-tabs">
                  <li class="nav-item">
                    <a class="nav-link" v-if="!_.isNull(user) && user.type == 2 || _.isNull(user)" :class="{ active : form.type == 2}" @click="form.type = 2" href="javascript:;">Kurumsal (LTD. A.Ş için seçiniz.)</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" v-if="!_.isNull(user) && user.type == 1 || _.isNull(user)" :class="{ active : form.type == 1}" @click="form.type = 1" href="javascript:;">Bireysel (Sadece Şahıs Ödemeleri)</a>
                  </li>
                </ul>
                <div class="tab-content">
                  <b-col cols="12" class="informations">
                      <div v-if="!user" style="padding:5px; margin:0px 0 0px 0px; border-radius:5px; width:100%;">
                        <p style="color:#000 !important; text-align:center;font-size:12px;">
                          Ödeme yapmadan önce <strong><router-link to="/login" style="color:#000!important;">Üye Girişi</router-link></strong> yaparsanız ödemeleriniz kaydedilir ve daha sonra
                          <br>tüm ödeme dekontlarınıza <strong>tahsilat.cetinkayapano.com</strong> üzerinden ulaşabilirsiniz.
                          <br>Üye girişi olmadan yapılan ödemeler daha sonra takip edilemez.
                        </p>
                      </div>
                      <h6 class="col" style="text-align:center;margin-bottom:5px;padding:10px 0 5px 0;border-top:1px solid #bbbbbb; ">Ödeme Yapan Firma Bilgileri</h6>
                      <b-col cols="12">
                        <b-row>
                          <b-col cols="6">
                              <b-form-input size="sm" v-model="form.company.name" aria-describedby="error_name" :state="(!_.isUndefined(errors['company.name']) ? false : formPost)" placeholder="Adınız"></b-form-input>
                              <b-form-invalid-feedback id="error_name">
                                {{ _.first(errors['company.name']) }}
                              </b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="6">
                              <b-form-input size="sm" v-model="form.company.surname" aria-describedby="error_surname" :state="(!_.isUndefined(errors['company.surname']) ? false : formPost)" placeholder="Soyadınız"></b-form-input>
                              <b-form-invalid-feedback id="error_surname">
                                {{ _.first(errors['company.surname']) }}
                              </b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="12">
                              <b-form-input size="sm" v-model="form.company.company_name" aria-describedby="error_company_name" :state="(!_.isUndefined(errors['company.company_name']) ? false : formPost)" placeholder="Firmanızın Resmi Ünvanı"></b-form-input>
                              <b-form-invalid-feedback id="error_company_name">
                                {{ _.first(errors['company.company_name']) }}
                              </b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="6">
                              <b-form-input size="sm" type="email" v-model="form.company.email" aria-describedby="error_email" :state="(!_.isUndefined(errors['company.email']) ? false : formPost)" placeholder="E-mail adresiniz"></b-form-input>
                              <b-form-invalid-feedback id="error_email">
                                {{ _.first(errors['company.email']) }}
                              </b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="6">
                              <b-form-input onKeyDown="if(this.value.length==11 && event.keyCode!=8) return false;" size="sm" type="number" v-model="form.company.phone" aria-describedby="error_phone" :state="(!_.isUndefined(errors['company.phone']) ? false : formPost)" placeholder="Telefon Numaranız"></b-form-input>
                              <b-form-invalid-feedback id="error_phone">
                                {{ _.first(errors['company.phone']) }}
                              </b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="6">
                              <b-form-input size="sm" v-model="form.company.tax_place" aria-describedby="error_tax_place" :state="(!_.isUndefined(errors['company.tax_place']) ? false : formPost)" placeholder="Vergi Dairesi"></b-form-input>
                              <b-form-invalid-feedback id="error_tax_place">
                                {{ _.first(errors['company.tax_place']) }}
                              </b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="6" v-if="form.type == 2">
                              <b-form-input onKeyDown="if(this.value.length==10 && event.keyCode!=8) return false;" size="sm" type="number" v-model="form.company.tax_number" aria-describedby="error_tax_number" :state="(!_.isUndefined(errors['company.tax_number']) ? false : formPost)" placeholder="Vergi Numarası"></b-form-input>
                              <b-form-invalid-feedback id="error_tax_number">
                                {{ _.first(errors['company.tax_number']) }}
                              </b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="6" v-if="form.type == 1">
                              <b-form-input onKeyDown="if(this.value.length==11 && event.keyCode!=8) return false;" size="sm" type="number" v-model="form.company.identity_id" aria-describedby="error_identity_id" :state="(!_.isUndefined(errors['company.identity_id']) ? false : formPost)" placeholder="TC Kimlik Numarası"></b-form-input>
                              <b-form-invalid-feedback id="error_identity_id">
                                {{ _.first(errors['company.identity_id']) }}
                              </b-form-invalid-feedback>
                          </b-col>
                          <b-col cols="12">
                              <b-form-input size="sm" v-model="form.company.address" aria-describedby="error_address" :state="(!_.isUndefined(errors['company.address']) ? false : formPost)" placeholder="Adresiniz"></b-form-input>
                              <b-form-invalid-feedback id="error_address">
                                {{ _.first(errors['company.address']) }}
                              </b-form-invalid-feedback>
                          </b-col>
                        </b-row>
                      </b-col>
                      <div class="card-wrapper" data-jp-card-initialized="true">
                        <div class="jp-card-container">
                            <div class="jp-card jp-card-unknown" :class="{ 'jp-card-flipped' : flip }">
                              <div class="jp-card-front">
                                  <div class="jp-card-logo jp-card-elo">
                                    <div class="e">e</div>
                                    <div class="l">l</div>
                                    <div class="o">o</div>
                                  </div>
                                  <div class="jp-card-logo jp-card-visa">Visa</div>
                                  <div class="jp-card-logo jp-card-visaelectron">
                                    Visa
                                    <div class="elec">Electron</div>
                                  </div>
                                  <div class="jp-card-logo jp-card-mastercard">Mastercard</div>
                                  <div class="jp-card-logo jp-card-maestro">Maestro</div>
                                  <div class="jp-card-logo jp-card-amex"></div>
                                  <div class="jp-card-logo jp-card-discover">discover</div>
                                  <div class="jp-card-logo jp-card-unionpay">UnionPay</div>
                                  <div class="jp-card-logo jp-card-dinersclub"></div>
                                  <div class="jp-card-logo jp-card-hipercard">Hipercard</div>
                                  <div class="jp-card-logo jp-card-troy">troy</div>
                                  <div class="jp-card-logo jp-card-dankort">
                                    <div class="dk">
                                        <div class="d"></div>
                                        <div class="k"></div>
                                    </div>
                                  </div>
                                  <div class="jp-card-logo jp-card-jcb">
                                    <div class="j">J</div>
                                    <div class="c">C</div>
                                    <div class="b">B</div>
                                  </div>
                                  <div class="jp-card-lower">
                                    <div class="jp-card-shiny"></div>
                                    <div class="jp-card-cvc jp-card-display jp-card-invalid">•••</div>
                                    <div class="jp-card-number jp-card-display jp-card-invalid">
                                      {{ !_.isNull(form.card.card_number) ? form.card.card_number : '•••• •••• •••• ••••' }}
                                      </div>
                                    <div class="jp-card-name jp-card-display jp-card-invalid">
                                      {{ !_.isNull(form.card.name) ? form.card.name : 'ADINIZ SOYADINIZ' }}
                                      </div>
                                    <div class="jp-card-expiry jp-card-display jp-card-invalid" data-before="month/year" data-after="valid
                                        thru">
                                        {{ !_.isNull(form.card.last_date_month) || !_.isNull(form.card.last_date_year) ? form.card.last_date_month + ' ' + form.card.last_date_year : '••/••' }}
                                        </div>
                                  </div>
                              </div>
                              <div class="jp-card-back">
                                  <div class="jp-card-bar"></div>
                                  <div class="jp-card-cvc jp-card-display jp-card-invalid">{{ form.card.cvv }}</div>
                                  <div class="jp-card-shiny"></div>
                              </div>
                            </div>
                        </div>
                      </div>

                      <b-col cols="12">
                        <b-row>
                          <b-col cols="6">
                              <b-form-group label="Kart Üzerindeki Ad Soyad">
                                <b-form-input size="sm" v-model="form.card.name" aria-describedby="error_card_name" :state="(!_.isUndefined(errors['card.name']) ? false : formPost)" placeholder="Adınız Soyadınız"></b-form-input>
                                <b-form-invalid-feedback id="error_card_name">
                                  {{ _.first(errors['card.name']) }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                          </b-col>
                          <b-col cols="6">
                              <b-form-group label="Kart No">
                                <b-form-input size="sm" onKeyDown="if(this.value.length==16 && event.keyCode!=8) return false;" v-model="form.card.card_number" aria-describedby="error_card_card_number" :state="(!_.isUndefined(errors['card.card_number']) ? false : formPost)" placeholder="**** **** **** ****"></b-form-input>
                                <b-form-invalid-feedback id="error_card_card_number">
                                  {{ _.first(errors['card.card_number']) }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                          </b-col>
                          <b-col cols="12" md="3">
                              <b-form-group label="Son Kullanma Tarihi">
                                <b-row>
                                  <b-col cols="6" style="padding-right: 5px;">
                                    <b-form-input size="sm" type="number" onKeyDown="if((this.value.length==2 && event.keyCode!=8)) return false;" aria-describedby="card_last_month" :state="(!_.isUndefined(errors['card.last_date_month']) ? false : formPost)" v-model="form.card.last_date_month" placeholder="Ay"></b-form-input>
                                    <b-form-invalid-feedback id="card_last_month">
                                      {{ _.first(errors['card.last_date_month']) }}
                                    </b-form-invalid-feedback>
                                  </b-col>
                                  <b-col cols="6" style="padding-left: 5px;">
                                    <b-form-input size="sm" type="number" onKeyDown="if(this.value.length==4 && event.keyCode!=8) return false;" v-model="form.card.last_date_year" aria-describedby="error_card_last_date_year" :state="(!_.isUndefined(errors['card.last_date_year']) ? false : formPost)"  placeholder="Yıl"></b-form-input>
                                    <b-form-invalid-feedback id="error_card_last_date_year">
                                      {{ _.first(errors['card.last_date_year']) }}
                                    </b-form-invalid-feedback>
                                  </b-col>
                                </b-row>
                              </b-form-group>
                          </b-col>
                          <b-col cols="3">
                              <b-form-group label="CVV">
                                <b-form-input onKeyDown="if(this.value.length==3 && event.keyCode!=8) return false;" type="number" @blur="flip = false" @focus="flip = true;" size="sm" aria-describedby="error_card_cvv" :state="(!_.isUndefined(errors['card.cvv']) ? false : formPost)" v-model="form.card.cvv" placeholder="CVV"></b-form-input>
                                <b-form-invalid-feedback id="error_card_cvv">
                                  {{ _.first(errors['card.cvv']) }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                          </b-col>
                          <b-col cols="6" md="3">
                              <b-form-group label="Tutar">
                                <b-form-input type="number" size="sm" aria-describedby="error_card_amount" :state="(!_.isUndefined(errors['card.amount']) ? false : formPost)" @keypress="onlyNumber" v-model="form.card.amount" placeholder="TL"></b-form-input>
                                <b-form-invalid-feedback id="error_card_amount">
                                  {{ _.first(errors['card.amount']) }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                          </b-col>
                          <b-col cols="3">
                              <b-form-group label="Kuruş">
                                <b-form-input type="number" size="sm" aria-describedby="error_card_cent"  onKeyDown="if(this.value.length==2 && event.keyCode!=8) return false;" @keypress="onlyNumber" :state="(!_.isUndefined(errors['card.cent']) ? false : formPost)" v-model="form.card.cent" placeholder="00"></b-form-input>
                                <b-form-invalid-feedback id="error_card_cent">
                                  {{ _.first(errors['card.cent']) }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                          </b-col>
                          <b-col cols="12">
                              <b-form-group>
                                <b-form-input size="sm" v-model="form.card.note" aria-describedby="error_card_note" :state="(!_.isUndefined(errors['card.note']) ? false : formPost)" placeholder="Ödeme Notunuz"></b-form-input>
                                <b-form-invalid-feedback id="error_card_note">
                                  {{ _.first(errors['card.note']) }}
                                </b-form-invalid-feedback>
                              </b-form-group>
                          </b-col>
                          <b-col cols="12">
                              <b-form-group>
                                <b-form-select size="sm" v-model="form.card.installment" class="form-control mb-3 form-control-sm"  placeholder="Ödeme Notunuz">
                                  <b-form-select-option disabled :value="null">Taksit Seçiniz</b-form-select-option>
                                  <b-form-select-option :value="2">2</b-form-select-option>
                                  <b-form-select-option :value="3">3</b-form-select-option>
                                  <b-form-select-option :value="4">4</b-form-select-option>
                                  <b-form-select-option :value="5">5</b-form-select-option>
                                  <b-form-select-option :value="6">6</b-form-select-option>
                                </b-form-select>
                              </b-form-group>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-row>
                          <hr class="mt-2">
                          <b-col cols="12" md="5" class="mb-3">
                              <div class="form-check">
                                  <input type="checkbox" class="form-check-input" id="exampleCheck1" required v-model="form.company.cancel_void_accept" value="1">
                                  <label class="form-check-label" for="exampleCheck1" style="font-size:12px;"><router-link :to="{ name : 'Page', params : { slug: 'gizlilik-politikasi'}}"><strong>İptal, İade, Gizlilik ve Güvenlik Politikaları</strong></router-link>'nı onaylıyorum.</label>
                              </div>
                              <div class="form-check">
                                  <input type="checkbox" class="form-check-input" id="exampleCheck2" required v-model="form.company.kvkk_accept" value="1">
                                  <label class="form-check-label" for="exampleCheck2" style="font-size:12px;"><router-link :to="{ name : 'Page', params : { slug: 'kvkk-aydinlatma-metni'}}"><strong>KVKK Aydınlatma Metni</strong></router-link>'ni onaylıyorum.</label>
                              </div>
                          </b-col>
                          <b-col cols="12" md="7" class="mb-3" style="text-align:right">
                            <table border="0" style="font-size:12px;font-weight:700; float:left">
                                  <tbody>
                                  <tr>
                                      <td>
                                          Aylık Ödenecek Tutar:
                                      </td>
                                      <td v-if="!_.isNull(form.card.installment)">
                                          <span> {{ form.card.amount / form.card.installment | toDouble }} TRY </span>
                                      </td>
                                  </tr>
                                  <tr>
                                      <td>
                                        Ödenecek Toplam Tutar:  
                                      </td>
                                      <td>
                                          <span id="spTotal"> {{ form.card.amount }}  TRY</span>
                                      </td>
                                  </tr>
                              </tbody></table>
                              <button v-on:click="send()" class="btn btn-primary pull-right" style="text-align:right;" type="button">3D Ödeme Yap</button>
                          </b-col>
                    </b-row>
                  </b-col>
                </div>
              </form>
          </b-row>
        </b-container>
      </slot>
    </div>
</template>

<script>
  import Pay from '../components/Pay'
  export default{
    name:'SinglePay',
    data(){
      return{
        isPay: false,
        loading:false,
        flip: false,
        errors: {},
        formPost:null,
        tam:null,
        pay: {},
        form:{
            type: 2,
            company:{
              name: null,
              surname: null,
              company_name: null,
              email: null,
              phone: null,
              tax_place: null,
              tax_number: null,
              identity_id: null,
              address: null,
              cancel_void_accept: null,
              kvkk_accept:null,
            },
            card:{
              name: null,
              card_number: null,
              last_date_month: null,
              last_date_year: null,
              cvv: null,
              amount: null,
              cent: null,
              note: null,
              installment:null,
            }
        }
      }
    },
    components:{
      Pay
    },
    computed:{
      user(){
        return this.$user();
      },
    },
    watch:{
      'form.card.last_date_month'(newVal,oldVal){
        setTimeout( ()=> {
          if(newVal > 12){
            this.form.card.last_date_month = 1;
          }
        }, 10)
      },
      'form.card.last_date_year'(newVal,oldVal){
        setTimeout( ()=> {
          if(newVal < 21){
            this.form.card.last_date_year = 2;
          }
        }, 10)
      }
    },
    created(){
      
      if(!_.isNull(this.user)){
        this.form.company.name = this.user.name;
        this.form.company.surname = this.user.surname;
        this.form.company.company_name = this.user.company_name;
        this.form.company.email = this.user.email;
        this.form.company.phone = this.user.phone;
        this.form.company.tax_place = this.user.tax_place;
        this.form.company.tax_number = this.user.tax_number;
        this.form.company.identity_id = this.user.identity_id;
        this.form.company.address = this.user.address;
        this.form.type = this.user.type;
      }
      
    },
    methods:{
      onlyNumber ($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57)) { // 46 is dot
            $event.preventDefault();
        }
      },
      send(){
        this.loading = true;
        axios.post('pay', this.form)
        .then((response) => {
            if(response.status){
              this.pay = response.data.data;
              this.isPay = true;
              setTimeout(() => {
                document.getElementById("button_pay").click();
              }, 2000);
              //this.$bvModal.show('paymentModal')
            }else{
              this.$store.dispatch('alert/message', { type: 'error', title: response.data.message });
            }
        })
        .catch((err) => {
          this.loading = false;
          this.formPost = true;
          this.errors = err.response.data.errors;
        })
        .finally(()=>{
          this.loading = false;
        });
      }
    }
  }
</script>
